import { forwardRef } from 'react';

import Icon, { IconProps } from '../Icon';

export const CopyIcon = forwardRef<SVGSVGElement, IconProps>((props, ref) => (
  <Icon ref={ref} viewBox="0 0 16 16" fill="currentColor" {...props}>
    <path
      fillRule="evenodd"
      d="M6.7 6c-.4 0-.7.3-.7.7v6.6c0 .4.3.7.7.7h6.6c.4 0 .7-.3.7-.7V6.7c0-.4-.3-.7-.7-.7H6.7Zm-2 .7c0-1.1.9-2 2-2h6.6a2 2 0 0 1 2 2v6.6a2 2 0 0 1-2 2H6.7a2 2 0 0 1-2-2V6.7Z"
      clipRule="evenodd"
    />
    <path
      fillRule="evenodd"
      d="M2.7 2c-.4 0-.7.3-.7.7v6.6c0 .4.3.7.7.7a.7.7 0 0 1 0 1.3 2 2 0 0 1-2-2V2.7c0-1.1.9-2 2-2h6.6a2 2 0 0 1 2 2 .7.7 0 1 1-1.3 0c0-.4-.3-.7-.7-.7H2.7Z"
      clipRule="evenodd"
    />
  </Icon>
));
export default CopyIcon;
